import React from 'react'

import Toast, { ToastProps } from '../../atoms/Toast'

import { Routes } from '../../../Routes'
import { ACCOUNT_KEY } from '../../../providers/AccountProvider'
import { getMessageFromError } from '../../../utilities'

const logoutRedirect = response => {
  // Removes info on user, redirects and saves error message
  localStorage.removeItem('session_user')
  localStorage.removeItem('session_token')
  localStorage.removeItem('version')
  localStorage.removeItem(ACCOUNT_KEY)
  window.location.href = Routes.LOGIN
  localStorage.setItem('403_error', response?.data.error_message)
}

export interface ErrorToastProps extends ToastProps {
  error?: any
  autoHideDuration?: number
}

const ErrorToast: React.FC<ErrorToastProps> = ({ error, ...props }) => {
  React.useEffect(() => {
    if (error) {
      console.error('Error', { err: error.err || error })
    }
  }, [error])

  if (!error) {
    return null
  }

  // Hide 401 but refresh to try and get the new token
  if (error) {
    let { err, auto, axiosError, response } = error

    if (!axiosError) {
      axiosError = err?.axiosError
    }
    // Account for response not being directly in the error object
    if (!response) {
      response = axiosError?.response
    }

    if (response?.status === 401) {
      logoutRedirect(response)
      //   // Request reloading the token
      //   handleReload()
      return null
    }

    if (response?.status === 403) {
      const code = response?.data?.error_code
      const isRestricted = ['eInsufficientPermission', 'eRestricted'].includes(
        code
      )

      if (auto && isRestricted) {
        // Prevent infinite redirect
        if (window.location.pathname !== Routes.PERM_ERROR) {
          // Redirect to permission error page
          window.location.href = Routes.PERM_ERROR
        }
        return null
      } else if (!auto) {
        logoutRedirect(response)
        return null
      }
    }
  }

  return (
    <Toast severity='error' {...props}>
      {error ? getMessageFromError(error) : ''}
    </Toast>
  )
}

export default React.memo(ErrorToast)
